// extracted by mini-css-extract-plugin
export default {"root":"PlasmicInProgressSign_root__fuH2e","text":"PlasmicInProgressSign_text__wfG-l"};